import http from "@/shared/services/http";
import {EmployeeParams} from "@/modules/employees/params";

export const createEmployee = (data: any) => http.post(`v1/employees`, data);
export const listEmployee = (params?: EmployeeParams) => http.get(`v1/employees`, { params });
export const singleEmployee = (id: string) => http.get(`v1/employees/${id}`);
export const updateEmployee = (id: string, data: any) => http.put(`v1/employees/${id}`, data);
export const deleteEmployee = (id: string) => http.delete(`v1/employees/${id}`);